
export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-white font-playfair">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center justify-center w-full md:w-auto">
              <h1>
                <a href="/">
                  <img 
                    src="https://static.readdy.ai/image/a19705f045df358eda503236ce656b36/846ee1e93f81f94b53dc3e9fa39ac791.png" 
                    alt="VTC Legal - Fractional General Counsel for AI and Tech Companies" 
                    className="h-16 w-auto"
                  />
                </a>
              </h1>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h1 className="text-4xl font-bold text-gray-900 mb-8 font-playfair">Terms of Service</h1>
        <p className="text-sm text-gray-600 mb-12 font-inter">Effective Date: January 1, 2026</p>

        <div className="prose max-w-none">
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Agreement to Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              By accessing and using vtclegal.com (the "Website") and our services, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Website or services.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Legal Services and Attorney-Client Relationship</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">No Attorney-Client Relationship</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              Visiting this Website, reviewing content, or contacting VTC Legal does not create an attorney-client relationship. An attorney-client relationship is established only through a signed written engagement agreement after conflicts clearance and mutual agreement on the scope of representation.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Confidentiality</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              Do not send confidential information through this Website or email until an attorney-client relationship has been established. Information sent prior to establishing such relationship may not be treated as confidential or privileged.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Jurisdictional Limitations</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              VTC Legal provides services only in jurisdictions where properly licensed. Sergio Torres is licensed to practice law in New York and California. Services in other jurisdictions may be provided in association with local counsel.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Use of Website</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Permitted Use</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              You may use this Website for lawful purposes only. You agree not to use the Website:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6 font-inter">
              <li>In any way that violates applicable laws or regulations</li>
              <li>To transmit or send unsolicited advertising or promotional material</li>
              <li>To impersonate any person or entity</li>
              <li>To interfere with the Website's security features</li>
              <li>To introduce viruses, malware, or harmful code</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Content Accuracy</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              While we strive to keep information current and accurate, the content on this Website is for general informational purposes only and should not be relied upon as legal advice. Laws change frequently, and you should consult with qualified counsel for specific legal guidance.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Engagement Terms</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Service Agreements</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              All legal services are provided pursuant to separate written engagement agreements that specify the scope of representation, fees, and terms of service. These Terms of Service do not constitute an engagement for legal services.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Fees and Payment</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              Fees for legal services are established in separate engagement agreements. Payment terms, billing practices, and fee structures will be clearly outlined in such agreements.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              The content, design, graphics, and other materials on this Website are protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, or create derivative works from our content without express written permission.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Disclaimers and Limitations of Liability</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">No Legal Advice</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              The information provided on this Website is not intended to create an attorney-client relationship and should not be considered legal advice. You should not act or rely on any information on this Website without seeking appropriate professional counsel.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Limitation of Liability</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              To the fullest extent permitted by law, VTC Legal shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of this Website or reliance on its content.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-4 font-playfair">Website Availability</h3>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              We do not guarantee that this Website will be available at all times or free from technical issues. We reserve the right to modify, suspend, or discontinue the Website at any time without notice.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Professional Conduct</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              VTC Legal is committed to maintaining the highest standards of professional conduct in accordance with applicable rules of professional responsibility, including but not limited to the New York Rules of Professional Conduct and California Rules of Professional Conduct.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Third-Party Links</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              This Website may contain links to third-party websites. These links are provided for convenience only, and we do not endorse or control the content of such websites. We are not responsible for the availability, content, or practices of third-party sites.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Governing Law</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              These Terms are governed by the laws of the State of New York, without regard to conflict of law principles. Any disputes arising under these Terms shall be resolved in the courts of New York.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              We reserve the right to modify these Terms at any time. Updated Terms will be posted on this page with a revised effective date. Your continued use of the Website after changes are posted constitutes acceptance of the revised Terms.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 font-playfair">Contact Information</h2>
            <p className="text-gray-700 leading-relaxed mb-4 font-inter">
              If you have questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 font-inter"><strong>VTC Legal</strong></p>
              <p className="text-gray-700 font-inter"><strong>Email:</strong> sergio@vtclegal.com</p>
              <p className="text-gray-700 font-inter"><strong>Phone:</strong> (443) 306-7487</p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 text-gray-900 py-20 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-600 text-sm font-inter">
            © 2026 VTC Legal. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
